import {gql, useMutation} from "@apollo/client";

const EDIT_DIV_MUTATION = gql`
mutation EditDivision($name: String!, $divisionId: Int!, $sport: String, $competitionLevel: String, $ageGroup: String, $mountDistance: Float, $pitchLimit: Int, $restingGames: Int, $waiverIds: [ID], $gameDuration: Int) {
  editDivision(name: $name, divisionId: $divisionId, sport: $sport, competitionLevel: $competitionLevel, ageGroup: $ageGroup, mountDistance: $mountDistance, pitchLimit: $pitchLimit, restingGames: $restingGames, waiverIds: $waiverIds, gameDuration: $gameDuration) {
    division {
      id
      slug
      name
      competitionLevel
      ageGroup
      description
      logo
      mountDistance
      pitchLimit
      gameDuration
      restingGames
      sport{
        key
        name
      }
      isOpen
      activeSeason {
        id
        slug
        name
        registrationStartDate
        registrationEndDate
        startDate
        endDate
        state
      }
      seasons {
        id
        name
        slug
      }
      waivers {
            id
            title
        }
    }
  }
}
`;

export default function EditDivMutation() {
    return useMutation(EDIT_DIV_MUTATION);
}
